import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import StartingPage from "./StartingPage";
import SummaryPage from "./SummaryPage";
import { getContentHeight } from "../../../../../utils/textUtils";
import { updateSection } from "../../../assignmentSlice";

const KeyPointsPage = ({ setCurrentStep, isPreview, isReview }) => {
  const dispatch = useDispatch();
  const { assignment, paragraph, section } = useSelector(
    (state) => state.assignment
  );

  const [currentPage, setCurrentPage] = useState(1);

  const handleStart = () => {
    setCurrentPage(2);
  };

  const handleComplete = () => {
    if (!isPreview && !isReview) {
      dispatch(
        updateSection({ sectionId: section.id, data: { is_finished: true } })
      );
    }
    alert("학습이 완료되었습니다.");
    setCurrentStep(2);
  };

  const renderContent = () => {
    if (currentPage === 1) {
      return (
        <StartingPage
          assignment={assignment}
          paragraph={paragraph}
          handleNext={handleStart}
        />
      );
    } else if (currentPage === 2) {
      return (
        <>
          <SummaryPage section={section} />
          {/* 오른쪽 방향 화살표 버튼 */}
          <button
            style={{
              position: "fixed", // 화면 고정
              right: "60px", // 우측 여백
              top: "50%", // 중앙 배치
              transform: "translateY(-50%)", // 정확한 수직 중앙 정렬
              border: "none",
              backgroundColor: "#FFF",
              color: "#BEBEBE",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={handleComplete}
          >
            <div
              style={{
                position: "absolute",
                width: "15px",
                height: "15px",
                borderTop: "2px solid #BEBEBE", // 상단 선
                borderRight: "2px solid #BEBEBE", // 우측 선
                transform: "rotate(45deg)", // 45도 회전
              }}
            ></div>
          </button>
        </>
      );
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#FFF",
        height: getContentHeight(),
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {renderContent()}
    </div>
  );
};

export default KeyPointsPage;
